<template>
  <sfs-form-modal
    :id="modalId"
    title="Edit Item"
    @on-hide="resetFormData"
  >
    <technician-payment-item-form
      v-bind="value"
      @on-submit="updateItem"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
      :new-form="false"
    />
  </sfs-form-modal>
</template>

<script>
import TechnicianPaymentItemForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'TechnicianPaymentItemEditModal',
  mixins: [formModalMixin],
  components: {
    TechnicianPaymentItemForm,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      modalId: `technician-payment-item-${this.value.id}-edit-modal`,
    };
  },
  methods: {
    updateItem(data, handleUpdate) {
      handleUpdate(this.$technicianPaymentsAPI.updateItem(this.value.id, data));
    },
    onSave(technicianPaymentItem) {
      this.closeModal();
      this.resetFormData();
      this.$emit('on-save', technicianPaymentItem);
    },
  },
};
</script>
